export const INSURANCE_2024_NOTICE_URL =
  'https://storage.googleapis.com/shine-public/product/insurances/insurance-notice-2024.pdf';

export const getInsuranceSummaryUrl = () => {
  return INSURANCE_2024_NOTICE_URL;
};
